import { Exclude, Expose } from "class-transformer";

@Exclude()
class CreateStaffCartDto {
    @Expose()
    readonly staff_id: number;
}

export default CreateStaffCartDto;
